import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import type Configuration from "../types/Configuration";

interface ErrorMetadata {
  [key: string]: any;
}

const bugsnagInit = (configuration: Configuration[]): void => {
  const appSettings = configuration?.[0]?.app_settings;
  const urlParams = new URLSearchParams(window.location.search);
  const userID = urlParams.get("emr_user_id");
  const userName = urlParams.get("emr_user_full_name");
  const userEmail = urlParams.get("emr_user_email");
  const customer_name = window.location.host.split(".")[0];
  if (appSettings.bugsnag_api_key && appSettings.release_stage) {
    Bugsnag.start({
      apiKey: appSettings.bugsnag_api_key,
      plugins: [new BugsnagPluginReact()],
      releaseStage: appSettings.release_stage,
      metadata: {
        customer: {
          stackName: customer_name,
        },
      },
      user: {
        id: userID,
        name: userName,
        email: userEmail,
      },
    });
  }
};

const logError = (
  error: Error,
  errorMetadata: ErrorMetadata | null = null
): void => {
  if (Bugsnag.isStarted()) {
    Bugsnag.notify(error, (event) => {
      event.addMetadata("custom", errorMetadata);
    });
  } else {
    console.error(error);
  }
};

export { bugsnagInit, logError };
